import { styled } from "@pigment-css/react";
import { HoverRowItem } from "@acto/taskpane/field-sales-2/components/primitives/Card";

export const MEETING_PREP_ROW_PADDING_BLOCK = "16";

// HoverRowItem pins the first row's top padding, so a taller rhythm has to restate it at the same
// specificity or the first row stays tighter than its siblings.
export const MeetingPrepRowItem = styled(HoverRowItem)(({ theme }) => ({
  paddingBlock: theme.fieldSalesTwo.spacing[MEETING_PREP_ROW_PADDING_BLOCK],
  paddingInline: theme.fieldSalesTwo.spacing[8],
  marginInline: `-${theme.fieldSalesTwo.spacing[8]}`,
  "&:first-of-type": {
    paddingTop: theme.fieldSalesTwo.spacing[MEETING_PREP_ROW_PADDING_BLOCK],
  },
}));
